import React from 'react';
import styled from '@emotion/styled';
import { Link } from "react-router-dom";

import { slugify } from '../helpers/helpers';

const Entry = styled.li`
  margin: 15px 0 25px;
  position: relative;
`;

const Title = styled.h2`
  border-bottom: 1px solid ${props => props.theme.colors.dark};
  color: ${props => props.theme.colors.dark};
  display: inline-block;
  font-size: ${props => props.theme.size.medium};
  font-weight: 500;
  text-transform: uppercase;
  margin-top: ${props => props.theme.size.small};
  margin-right: 15px;
  padding-right: 100px;
  padding-bottom: ${props => props.theme.size.xsmall};
  width: 100%;

  ${props => props.theme.breakpoint.tablet} {
    font-size: ${props => props.theme.size.large};
    padding-right: 80px;
  }
`;

const Button = styled.button`
  background-color: transparent;
  border: 0;
  color: ${props => props.theme.colors.dark};
  font-size: ${props => props.theme.size.small};
  display: inline;
  margin-top: ${props => props.theme.size.large};
  margin-right: 15px;
  opacity: 0.5;
  text-decoration: underline;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const List = styled.ul`
  list-style-type: none;
  padding: ${props => props.theme.size.large};
`;

class PlannerList extends React.Component {
  constructor(props) {
    super(props);
    this.removePlanner = this.removePlanner.bind(this);
  }

  removePlanner(event) {
    let response = window.confirm('You are about to delete "' + event.target.getAttribute('data-planner') + '"');
    response && this.props.removePlanner(event.target.getAttribute('data-planner'));
  }

  render() {
    return (
      <List>
        {this.props.activities.map( planner => (
          <Entry key={planner.title}>
            <Link to={`/${slugify(planner.title)}`}><Title>{ planner.title }</Title></Link>
            <Button onClick={this.removePlanner} data-planner={planner.title}>Remove</Button>
          </Entry>
        ))}
      </List>
    );
  }
}

export default PlannerList;
